module.exports = __webpack_public_path__ + "h5/img/star.d096e736.gif";